/**
 * useSEO — fetcha /api/seo/summary (módulo SEO).
 *
 * Retorna { data, loading, error, refetch }. Re-busca quando período ou
 * cliente mudam. Espelha useDashboard p/ paridade de comportamento.
 */

import { useState, useEffect, useCallback, useRef } from 'react'
import { getSEOSummary, setSelectedClientId } from '../db/api.js'

export function useSEO(startDate, endDate, clientId) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  const refetch = useCallback(async () => {
    if (!startDate || !endDate) return
    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)
    try {
      setSelectedClientId(clientId)
      const result = await getSEOSummary(startDate, endDate)
      if (requestId !== requestIdRef.current) return
      setData(result)
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('[useSEO] fetch error:', err)
      setError(err.message || 'Erro ao carregar SEO')
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [startDate, endDate, clientId])

  useEffect(() => { refetch() }, [refetch])

  return { data, loading, error, refetch }
}
